export default "__VITE_ASSET__36b4639b__"